export class Segment {
    uid: string;
    description: string;
}



// WEBPACK FOOTER //
// ./src/app/model/segments.ts